/* eslint-disable arrow-body-style */
/* eslint-disable spaced-comment */
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { ConditionFilter } from "../../components/search-bar/search-filter/search-filter.component";
import { pattern } from "../../constants/patterns";
import { AnyObject } from "../../types/app.type";

export function getUpdatedValues(form: FormGroup, data: any, include?: string[]) {
  const updatedFormValues = {};
  form["_forEachChild"]((control: FormControl, name: string) => {
    if ((control.dirty && control.value != data[name]) || include?.includes(name)) {
      updatedFormValues[name] = control.value;
    }
  });
  return updatedFormValues;
}

export function isRequiredField(form: FormGroup, field: string) {
  const formField = form.get(field);
  if (!formField.validator) {
    return false;
  }

  const validator = formField.validator({} as AbstractControl);
  return validator && validator.required;
}

export function passwordValidator(passwordInputName: string, confirmationInputName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const newPassword = control.get(passwordInputName).value;
    const confirmPassword = control.get(confirmationInputName).value;

    if (!newPassword || !confirmPassword) {
      return null;
    }

    const result = newPassword === confirmPassword ? null : { notSame: true };
    control.get(confirmationInputName).setErrors(result);

    return result;
  };
}

export function setFilterCondition(where: AnyObject, condition: ConditionFilter): AnyObject {
  if (!where) {
    return {};
  }
  const keys = Object.keys(where);
  return keys.reduce((prev, curr) => {
    return { ...prev, ...{ [curr]: { [condition]: where[curr] } } };
  }, {});
}

/**
 * Validate if the passed value is a valid price
 * @param value value to validate
 * @returns
 */
export function isValidPrice(value: string | number): boolean {
  return !!String(value).match(pattern.price);
}
